import React from "react";
import SingleEventPage from "../../components/single-event-page/SingleEventPage";
import BugBustersImg from "../../assets/event-images/bug-busters.jpg";

const codeGolf = {
  image: BugBustersImg,
  description:
    'Join us for the event of programming competition where participants implement the solution with shortest time and space complexity wins the prize',
  type: "Technical Event",
  eventName: "Code Golf",
  dateTime: "March 1, 09:30AM - 11:00AM",
  venue: "IT-442",
  rules: [
    "Solo participation is allowed.",
    "1 Round consisting of 3 questions",
    "1st ques - 10 min",
    "2nd ques - 20 min",
    "3rd ques - 30 min",
    "Participants must write the shortest possible code (in terms of time complexity and space complexity) to solve the given problem.",
    "The problem statement will consist of input and output requirements. Participants must deduce the logic and implement it in code.",
    "The code can be written in any programming language.",
    "Participants should bring their own laptops for the event.",
    "All code must be written during the competition. Using pre-written libraries, plagiarized content, or external assistance is strictly prohibited.",
    "The code must be functional and produce the correct output for all test cases.",
    "The participant with the shortest correct solution to all the given problems, while considering time and space complexities, within the given timeframe, will be declared the winner."
],
  firstprize: 1000,
  secondprize: 500,
  thirdprize: 0,
  contact: [
    {
      name: "Nandhana",
      phoneNo: "9500756512",
    },
    {
      name: "Elankumaran",
      phoneNo: '7604992336',
    },
  ],
};

const CodeGolf = () => {
  return <SingleEventPage eventDetails={codeGolf} />;
};

export default CodeGolf;
